/**
 * @typedef {object} OwnedCollectionFilters
 * @property {string|null|undefined} minRating
 * @property {string|null|undefined} rating
 * @property {string|null|undefined} minBGGRating
 * @property {boolean} rated
 * @property {boolean} played
 * @property {boolean} comment
 * @property {boolean} hideExpansions
 */

/**
 * Query params shared by all /collection requests (per username).
 * @param {OwnedCollectionFilters} filters
 * @returns {object}
 */
export function buildOwnedCollectionParams(filters) {
	const {
		minRating = null,
		rating = null,
		minBGGRating = null,
		rated = false,
		played = false,
		comment = false,
		hideExpansions = false,
	} = filters || {}
	return {
		stats: 1,
		own: 1,
		minrating: minRating === 'any' ? null : minRating,
		rating: rating === 'any' ? null : rating,
		minbggrating: minBGGRating === 'any' ? null : minBGGRating,
		rated: rated ? 1 : null,
		played: played ? 1 : null,
		comment: comment ? 1 : null,
		excludesubtype: hideExpansions ? 'boardgameexpansion' : null,
	}
}

/**
 * Split comma-separated BGG usernames into a non-empty trimmed list.
 * @param {string} input
 * @returns {string[]}
 */
export function parseCommaSeparatedUsernames(input) {
	if (input == null) return []
	const s = String(input).trim()
	if (!s) return []
	if (s.includes(',')) {
		return s
			.split(',')
			.map((u) => u.trim())
			.filter(Boolean)
	}
	return [s]
}
